const JobDetailsRightPanel = () => {
  return (
    <div className="w-[25%] rounded-md bg-white border h-max overflow-hidden">
      <div className="flex items-center relative gap-2 p-5">
        <div className="rounded-md bg-charcoal text-white text-3xl font-medium h-10 w-10 flex items-center justify-center shrink-0">
          J
        </div>
        <div className="flex flex-col gap-0.5">
          <span className="uppercase text-xss tracking-wider font-semibold text-light-black">
            Job Post
          </span>
          <span className="font-semibold text-sm">Job posting fee test</span>
          <span className="font-semibold text-content-muted text-xss">
            JO-T17270
          </span>
          <span className="text-xss font-medium text-light-black">
            Hiring company · Company not disclosed
          </span>
        </div>
        <div className="self-start rounded-full bg-gray-100 text-xss text-content-muted font-semibold py-1 px-2">
          Closed
        </div>
      </div>

      <div className="flex border-t border-light-gray flex-1 gap-2 px-5 py-3">
        <button className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold">
          Edit job
        </button>
        <button className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold">
          Withdraw job post
        </button>
      </div>

      <div className="flex flex-col pl-5 bg-black py-4">
        <span className="text-white font-medium text-sm">
          Publishing details
        </span>
        <span className="text-light-grey text-xss">Current job post</span>
      </div>
    </div>
  );
};

export default JobDetailsRightPanel;
